import type { ServicesData, ServicesResponse } from '../types/services-page';

export const ServicesPageFallbackData: ServicesData = {
  id: 1,
  documentId: 'gyp8pq84xsv7443ex44mffub',
  createdAt: '2025-08-20T04:24:35.016Z',
  updatedAt: '2025-08-20T04:24:35.016Z',
  publishedAt: null,
  locale: null,
  seo: {
    id: 5,
    metaTitle: 'Dịch Vụ - Công Ty TNHH Cơ Khí Chính Xác Bách Việt',
    metaDescription:
      'Khám phá các dịch vụ cơ khí chính xác của Bách Việt - từ gia công CNC đến sản xuất linh kiện chất lượng cao tại Hà Nội.',
    keywords: 'dịch vụ cơ khí, gia công CNC, linh kiện, Bách Việt, Hà Nội',
    metaImage: null,
  },
  hero: {
    id: 4,
    title: 'DỊCH VỤ CỦA CHÚNG TÔI',
    content:
      'Chuyên cung cấp các dịch vụ cơ khí chính xác chất lượng cao, đáp ứng mọi nhu cầu sản xuất và gia công của khách hàng.',
    backgroundImage: null,
  },
  whyChooseUs: {
    id: 1,
    title: 'TẠI SAO CHỌN CHÚNG TÔI',
    subtitle: 'Những lý do khiến Bách Việt trở thành đối tác tin cậy của bạn',
    items: [
      {
        id: 1,
        title: 'Kinh nghiệm lâu năm',
        description:
          'Với hơn 10 năm kinh nghiệm trong lĩnh vực cơ khí chính xác, chúng tôi hiểu rõ mọi yêu cầu của khách hàng.',
        icon: {
          id: 40,
          documentId: 'w3bcbfm7h441lsor51osvg17',
          name: 'icon-srv-1.svg',
          alternativeText: 'An image uploaded to Strapi called icon-srv-1.svg',
          caption: 'An image uploaded to Strapi called icon-srv-1.svg',
          width: 82,
          height: 82,
          formats: null,
          hash: 'icon_srv_1_df9a4c2fef',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 5.81,
          url: '/uploads/icon_srv_1_df9a4c2fef.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-20T04:24:34.971Z',
          updatedAt: '2025-08-20T04:24:34.971Z',
          publishedAt: '2025-08-20T04:24:34.971Z',
          locale: null,
        },
      },
      {
        id: 2,
        title: 'Công nghệ hiện đại',
        description:
          'Sử dụng máy móc CNC hiện đại, đảm bảo độ chính xác cao và chất lượng sản phẩm vượt trội.',
        icon: {
          id: 41,
          documentId: 'g8ccf2mjigndgacc4r00bol9',
          name: 'icon-srv-2.svg',
          alternativeText: 'An image uploaded to Strapi called icon-srv-2.svg',
          caption: 'An image uploaded to Strapi called icon-srv-2.svg',
          width: 82,
          height: 82,
          formats: null,
          hash: 'icon_srv_2_7428130eaa',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 9.15,
          url: '/uploads/icon_srv_2_7428130eaa.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-20T04:24:34.980Z',
          updatedAt: '2025-08-20T04:24:34.980Z',
          publishedAt: '2025-08-20T04:24:34.980Z',
          locale: null,
        },
      },
      {
        id: 3,
        title: 'Đội ngũ chuyên nghiệp',
        description:
          'Đội ngũ kỹ thuật viên lành nghề, được đào tạo bài bản và có kinh nghiệm thực tế.',
        icon: {
          id: 42,
          documentId: 'oxpvdkup8kw7pq5vrv6jf9k2',
          name: 'icon-srv-3.svg',
          alternativeText: 'An image uploaded to Strapi called icon-srv-3.svg',
          caption: 'An image uploaded to Strapi called icon-srv-3.svg',
          width: 82,
          height: 82,
          formats: null,
          hash: 'icon_srv_3_d2bfcd5f4b',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 7.62,
          url: '/uploads/icon_srv_3_d2bfcd5f4b.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-20T04:24:34.990Z',
          updatedAt: '2025-08-20T04:24:34.990Z',
          publishedAt: '2025-08-20T04:24:34.990Z',
          locale: null,
        },
      },
      {
        id: 4,
        title: 'Dịch vụ tận tâm',
        description:
          'Cam kết cung cấp dịch vụ chất lượng cao với sự tận tâm và trách nhiệm cao nhất.',
        icon: {
          id: 43,
          documentId: 'mdhscqwd4qzhug61007b0wcr',
          name: 'icon-srv-4.svg',
          alternativeText: 'An image uploaded to Strapi called icon-srv-4.svg',
          caption: 'An image uploaded to Strapi called icon-srv-4.svg',
          width: 82,
          height: 82,
          formats: null,
          hash: 'icon_srv_4_742d416988',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 7.39,
          url: '/uploads/icon_srv_4_742d416988.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-20T04:24:34.999Z',
          updatedAt: '2025-08-20T04:24:34.999Z',
          publishedAt: '2025-08-20T04:24:34.999Z',
          locale: null,
        },
      },
      {
        id: 5,
        title: 'Thúc đẩy sáng tạo',
        description:
          'Cam kết cung cấp dịch vụ chất lượng cao với sự tận tâm và trách nhiệm cao nhất.',
        icon: {
          id: 44,
          documentId: 'zvagu69li5lxppz3ovlhafw2',
          name: 'icon-srv-5.svg',
          alternativeText: 'An image uploaded to Strapi called icon-srv-5.svg',
          caption: 'An image uploaded to Strapi called icon-srv-5.svg',
          width: 82,
          height: 82,
          formats: null,
          hash: 'icon_srv_5_a9c7f10cb4',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 4.95,
          url: '/uploads/icon_srv_5_a9c7f10cb4.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-20T04:24:35.008Z',
          updatedAt: '2025-08-20T04:24:35.008Z',
          publishedAt: '2025-08-20T04:24:35.008Z',
          locale: null,
        },
      },
    ],
  },
  servicesList: {
    id: 1,
    title: 'DANH SÁCH DỊCH VỤ',
    overviewTitle: 'Tổng quan dịch vụ',
    services: [
      {
        order: null,
        id: 4,
        title: 'Gia công CNC',
        description:
          'Gia công cơ khí chính xác bằng máy CNC, đảm bảo độ chính xác cao và chất lượng sản phẩm.',
        overview:
          'Sử dụng công nghệ CNC hiện đại để gia công các chi tiết cơ khí với độ chính xác cao.',
        isActive: true,
        buttonText: null,
        buttonLink: null,
      },
      {
        order: null,
        id: 5,
        title: 'Sản xuất linh kiện',
        description:
          'Sản xuất các linh kiện cơ khí theo yêu cầu, đáp ứng mọi tiêu chuẩn kỹ thuật.',
        overview:
          'Chuyên sản xuất các linh kiện cơ khí chất lượng cao theo thiết kế của khách hàng.',
        isActive: true,
        buttonText: null,
        buttonLink: null,
      },
      {
        order: null,
        id: 6,
        title: 'Thiết kế và tư vấn',
        description:
          'Tư vấn thiết kế và cung cấp giải pháp tối ưu cho các dự án cơ khí.',
        overview:
          'Đội ngũ kỹ sư giàu kinh nghiệm sẵn sàng tư vấn và thiết kế theo yêu cầu.',
        isActive: true,
        buttonText: null,
        buttonLink: null,
      },
      {
        order: null,
        id: 7,
        title: 'Bảo trì và sửa chữa',
        description:
          'Dịch vụ bảo trì, sửa chữa máy móc và thiết bị cơ khí chuyên nghiệp.',
        overview:
          'Cung cấp dịch vụ bảo trì định kỳ và sửa chữa khẩn cấp cho máy móc cơ khí.',
        isActive: true,
        buttonText: null,
        buttonLink: null,
      },
    ],
  },
  faqSection: {
    id: 1,
    title: 'CÂU HỎI THƯỜNG GẶP',
    faqs: [
      {
        id: 1,
        question: 'Bách Việt có cung cấp dịch vụ gia công CNC không?',
        answer:
          'Có, chúng tôi chuyên cung cấp dịch vụ gia công CNC với độ chính xác cao và chất lượng đảm bảo.',
        isExpanded: false,
      },
      {
        id: 2,
        question: 'Thời gian hoàn thành một dự án gia công thường mất bao lâu?',
        answer:
          'Thời gian hoàn thành phụ thuộc vào độ phức tạp của dự án. Thông thường từ 1-4 tuần cho các dự án vừa và nhỏ.',
        isExpanded: false,
      },
      {
        id: 3,
        question: 'Bách Việt có nhận gia công theo yêu cầu riêng không?',
        answer:
          'Có, chúng tôi nhận gia công theo mọi yêu cầu riêng của khách hàng, từ thiết kế đến sản xuất.',
        isExpanded: false,
      },
      {
        id: 4,
        question: 'Chất lượng sản phẩm có được đảm bảo không?',
        answer:
          'Chúng tôi cam kết chất lượng sản phẩm 100% và có chính sách bảo hành rõ ràng cho mọi sản phẩm.',
        isExpanded: false,
      },
    ],
  },
};

export const ServicesPageFallbackResponse: ServicesResponse = {
  data: ServicesPageFallbackData,
  meta: {
    pagination: {
      page: 1,
      pageSize: 25,
      pageCount: 1,
      total: 1,
    },
  },
};
